import { render, staticRenderFns } from "./Czrz.vue?vue&type=template&id=b947a7ca&scoped=true&"
import script from "./Czrz.vue?vue&type=script&lang=js&"
export * from "./Czrz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b947a7ca",
  null
  
)

export default component.exports